import { SELECIONAR_VEICULO } from '../types'

export default function selecionarVeiculo (veiculo) {
  return {
    type: SELECIONAR_VEICULO,
    payload: veiculo
  }
}